// import { useEffect, useState } from "react";
import { Card, Container, Image } from "react-bootstrap";
import { homes } from "../Data/home_stays.js";
// import { fetchAllHomeStay } from "../Services/api.js";


export function HomeStay() {
    // const [home, setHome] = useState([]);
    // const fetchHome = async () => {
    //     const response = await fetchAllHomeStay();
    //     setHome(response.data);
    //     console.log(response.data);
    // }
    // useEffect(() => {
    //     fetchHome();
    // }, []);

    return (
        <>
            <div>
                <Image src="https://seoimgak.mmtcdn.com/blog/sites/default/files/images/resorts-in-uttarakhand-riverview-retreat.jpg" alt="OM" style={{ width: '100%', height: '300px' }}></Image>
            </div>
            <Container className="my-5 text-center">
            <h1 style={{ borderRadius: "20px", background: '#0D6EFD', color: 'white', boxShadow: '5px 5px lightblue' , padding: '10px' }}>HOMESTAY LISTING</h1>
            </Container>
            <Container>
           

            <div className="mx-2" style={{display: "flex", flexDirection: "row", overflow: "hidden", flexWrap: "wrap", justifyContent: "center", alignItems: 'center', width: "100%", gap: "10px"}}>
                
                        {
                            homes.map((e, index) => {
                                return (
                                    <Card key={index} style={{ width: '30rem', boxShadow: '-1px 4px 5px 0.5px rgb(0 0 0 / 10%)', borderRadius: '10px'}}>
                                    <Card.Body>
                                      <Card.Title><strong>Name:</strong> {e.name}</Card.Title>
                  
                                      <Card.Text>{e.phone}</Card.Text>
                                      <Card.Text><strong>Address:</strong> {e.address}</Card.Text>
                                      <Card.Text><strong>Email:</strong> {e.email}</Card.Text>
                                      
                                    </Card.Body>
                                  </Card>
                                )
                            })
                        }
                    
            </div>
            </Container>
        </>
    );
}